module.exports = __webpack_public_path__ + "img/Pic_IONE_PT.80f84ea9.png";